import styled from 'vue-styled-components'

const FloatFrameMarginResizeContainer = styled.div`
  position: relative;
  height: 100%;
  &::after{
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    top: 50%;
    border-top: 1px dashed #12A9FF;
    z-index: -1;
  }
  `
const WrapperProps = {
  position: {},
}
const FloatFrameMarginResizeWrapper = styled('div', WrapperProps)`
  // pointer-events: none;
  position: absolute;
  width: ${({ position }) => position.width};
  top: ${({ position }) => position.top};
  left: ${({ position }) => position.left};
  &.active{
    background: #12a9ff59;
  }
  /* border: 3px solid red; */
`
const FloatFrameMarginResizeContent = styled.div`

`
const ToolIcon = styled.div`
  position: relative;
  background-color: #12A9FF;
  color: #ffffff;
  height: 25px;
  border-radius: 20px;
  padding: 0px 9px;
`
const ToolLabel = styled.div`
position: absolute;
background-color: #12A9FF;
color: #ffffff;
height: 25px;
left: 100%;
border-radius: 4px;
`
const ToolIconWrapper = styled.div`
position: relative;
width: fit-content;
`
export {
  FloatFrameMarginResizeWrapper,
  FloatFrameMarginResizeContainer,
  FloatFrameMarginResizeContent,
  ToolIcon,
  ToolLabel,
  ToolIconWrapper
}